import {createActions} from 'client/framework';

const normalActions = ['INIT_STORE', 'UPDATE_OFFSET'];

export default createActions(null, normalActions);
